import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Response, Http } from '@angular/http';

import * as _ from 'lodash';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { ICoreService } from '../../../+common/contracts/core.service.contract';
import { Product } from '../model/product.model';
import { IPerson } from '../../../+common/contracts/person.model.contract';
import { ProductCategory } from '../model/product-category.model';
import { WashingType } from '../model/washing-type.model';
import { Garment } from '../model/garment.model';
import { WearLevel } from '../model/wear-level.model';
import { LaundryInputOutput } from '../model/laundry-input.model';
import { Slot } from '../model/slot.model';
import { SlotRequest } from '../model/slot-request.model';
import { ShelfBox } from '../model/shelf-box.model';
import { LaundryDelivery } from '../model/laundry-delivery.model';
import { Status } from 'app/+common/model/status.model';
import { LockReason } from '../model/lock-reason.model';
import { LaundryEvent } from '../model/laundry-event.model';
import { IInstanceService } from 'app/+common/contracts/instance-service.contract';
import { ShelfBoxMicro } from '../model/shelf-box-micro.model';

@Injectable()
export class CoreService implements ICoreService
{
    // private _backendUrl;
    private _instanceType;    

    private selectedTag: string;
    private selectedProduct: Product;
    private selectedProductCategory: ProductCategory;
    private selectedEndUser: IPerson;
    private selectedShelfBox: ShelfBox;
    private selectedShelfNumber: number;
    private selectedDeliveryMode: string;
    private selectedGarment: Garment;

    private productListSubject: BehaviorSubject<Product[]>;
    private productList$: Observable<Product[]>;
    private productList: Product[];

    private lastGarmentReadDate: Date;

    private MIN_INTERVAL_BETWEEN_TAG_SCAN = 2000;

    // getProductList$() { return this.productList$; }

    get backendUrl(): string
    {
        return localStorage.getItem("backendURL");
    }
    // set backendUrl(url: string)
    // {
    //     this._backendUrl = url;
    // }

    get instanceType(): string
    {
        if (this._instanceType && this._instanceType != "")
            return this._instanceType;
        else
            return localStorage.getItem("exaco-instance-type");
    }
    set instanceType(type: string)
    {
        this._instanceType = type;
    }

    getProductList$(customerId: string, categoryId: number): Observable<Product[]>
    {
        //const prods = localStorage.getItem("exaco-products")

        //return !!prods ? Observable.from([JSON.parse(prods)]) :
        return this.http
            .get(this.backendUrl + 'products/' + customerId + '/' + categoryId)
            .map(prods => { 
                localStorage.setItem("exaco-products", JSON.stringify(prods)) 
                return prods
            })
            .catch(this.handleError);
    }

    private productSubject: BehaviorSubject<Product>;
    private product$: Observable<Product>;
    private product: Product;
    // getProduct$() { return this.product$; }

    private garmentListSubject: BehaviorSubject<Garment[]>;
    private garmentList$: Observable<Garment[]>;
    private garmentList: Garment[];
    getGarmentList$() { return this.garmentList$; }

    private garmentSubject: BehaviorSubject<Garment>;
    private garment$: Observable<Garment>;
    private garment: Garment;

    getGarment$() { return this.garment$; }

    private lastGarmentsInputSubject: BehaviorSubject<Garment[]>;
    private lastGarmentsInput$: Observable<Garment[]>;
    private lastGarmentsInput: Garment[];
    getLastGarmentsInput$() { return this.lastGarmentsInput$; }

    private lastGarmentsOutputSubject: BehaviorSubject<Garment[]>;
    private lastGarmentsOutput$: Observable<Garment[]>;
    private lastGarmentsOutput: Garment[];
    getLastGarmentsOutput$() { return this.lastGarmentsOutput$; }

    private garmentPerson$: Observable<IPerson>;

    // Lookups
    private wearLevelList: WearLevel[];
    private washingTypeList: WashingType[];
    private lockReasonInList: LockReason[];
    private lockReasonOutList: LockReason[];

    constructor(private http: HttpClient, private httpOld: Http, @Inject('IInstanceService') private instanceService: IInstanceService)
    {
        this.httpOld.get('assets/configuration/environment.json')
            .map(res => res.json())
            .toPromise()
            .then((config) =>
            {
                // this.backendUrl = config.url;
                this.instanceType = config.env;
                localStorage.setItem("backendURL", config.url);
                localStorage.setItem("exaco-instance-type", config.env);

                console.log(config.url);
                console.log(config.env);
                // Lookup caching
                this.preloadLookups();
            });

        this.productListSubject = new BehaviorSubject<Product[]>([]);
        this.productList$ = this.productListSubject.asObservable();
        this.productList$.subscribe(res => this.productList = res, err => console.error(err));

        this.productSubject = new BehaviorSubject<Product>({});
        this.product$ = this.productSubject.asObservable();
        this.product$.subscribe(res => this.product = res, err => console.error(err));

        this.garmentListSubject = new BehaviorSubject<Garment[]>([]);
        this.garmentList$ = this.garmentListSubject.asObservable();
        this.garmentList$.subscribe(res => this.garmentList = res, err => console.error(err));

        this.garmentSubject = new BehaviorSubject<Garment>({});
        this.garment$ = this.garmentSubject.asObservable();
        this.garment$.subscribe(res => this.garment = res, err => console.error(err));

        this.lastGarmentsInputSubject = new BehaviorSubject<Garment[]>([]);
        this.lastGarmentsInput$ = this.lastGarmentsInputSubject.asObservable();
        this.lastGarmentsInput$.subscribe(res => this.lastGarmentsInput = res, err => console.error(err));

        this.lastGarmentsOutputSubject = new BehaviorSubject<Garment[]>([]);
        this.lastGarmentsOutput$ = this.lastGarmentsOutputSubject.asObservable();
        this.lastGarmentsOutput$.subscribe(res => this.lastGarmentsOutput = res, err => console.error(err));

        // // Lookup caching
        // this.preloadLookups();

        this.lastGarmentReadDate = new Date();
    }

    preloadLookups()
    {
        this.http
            .get(this.backendUrl + 'washing-types')
            .map(this.extractData)
            .subscribe(
                res => this.washingTypeList = res,
                err => console.error(err)
            );

        this.http
            .get(this.backendUrl + 'wear-levels')
            .map(this.extractData)
            .subscribe(
                res => this.wearLevelList = res,
                err => console.error(err)
            );

        // TODO: unmock in a service
        this.lockReasonInList = [{ id: 1, name: 'Cambio Taglia' }, { id: 2, name: 'Riparazione' }];
        this.lockReasonOutList = [{ id: 1, name: 'Cambio Taglia' }, { id: 2, name: 'Riparazione' }, { id: 3, name: 'Rilavaggio' }];

    }

    private extractData(res: any)
    {
        let body = res; //.json();
        return body;// || {};
    }
    private handleError(error: Response | any)
    {
        // In a real world app, you might use a remote logging infrastructure
        let errMsg: string;
        if (error instanceof Response)
        {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        }
        else
        {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }

    // getProductList(customerId: string, categoryId: number): void
    // {
    //     if (
    //         typeof this.productList === 'undefined' ||
    //         !this.productList ||
    //         this.productList.length === 0
    //     )
    //     {
    //         this.refreshProductList(customerId, categoryId);
    //     }
    //     else
    //     {
    //         this.productListSubject.next(this.productList);
    //     }
    // }

    refreshProductList(customerId: string, categoryId: number): void
    {
        this.http
            .get(this.backendUrl + 'products/' + customerId + '/' + categoryId)
            .map(this.extractData)
            .subscribe(
                res => this.productListSubject.next(res),
                err => console.error(err)
            );
    }

    getProductCategoryList$(): Observable<ProductCategory[]>
    {
        return this.http.get(this.backendUrl + "product-categories")
            .map(this.extractData)
            .catch(this.handleError);
    }

    getProduct(customerId: string, productId: number): void
    {
        throw new Error("Method not implemented.");
    }

    getProduct$(customerId: string, productId: number): Observable<Product>
    {
        return this.http
            .get(this.backendUrl + `products/${productId}`)
            .map(this.extractData);
    }

    setProduct$(product: Product): Observable<Product>
    {
        return this.http
            .post(this.backendUrl + 'products', product)
            .map(this.extractData)
            .catch(this.handleError);
    }

    // getProduct(customerId: string, productId: number): void
    // {
    //     const product = this.productList.find(x => x.id === productId);
    //     if (product)
    //     {
    //         this.productSubject.next(product)
    //     } else
    //     {
    //         this.http
    //             .get(this.backendUrl + `products/${ productId }`)
    //             .map(this.extractData)
    //             .subscribe(res => this.productSubject.next(res), err => console.error(err));
    //     }
    // }

    // getProductListByOwner(
    //     customerId: string,
    //     ownerId: number
    //   ): Promise<Product[]> {
    //     throw new Error('Method not implemented.');
    //   }
    getCategory(customerId: string, categoryId: number): Promise<ProductCategory>
    {
        throw new Error('Method not implemented.');
    }

    getCategoryByProduct(customerId: string, productId: number): Promise<ProductCategory>
    {
        throw new Error('Method not implemented.');
    }
    getGarmentList(customerId: string): Observable<Garment[]>
    {
        throw new Error('Method not implemented.');
    }

    // Ezio: TODO: obsolete with the new BehaviourSubject: remove from interface and from concrete
    getProductListByOwner(customerId: string, ownerId: number): Promise<Product[]>
    {
        throw new Error("Method not implemented.");
    }

    // Ezio: TODO: remove it if not needed anymore
    getGarmentListSync(customerId: string): Garment[]
    {
        throw new Error("Method not implemented.");
    }

    getGarmentListByOwner(customerId: string, ownerId: number): void
    {
        if (
            typeof this.garmentList === 'undefined' ||
            !this.garmentList ||
            this.garmentList.length === 0
        )
        {
            this.refreshGarmentList(customerId, ownerId);
        } else
        {
            this.garmentListSubject.next(this.garmentList);
        }
    }

    getGarmentListByRFIDList(rfidList: Array<string>): Observable<Garment[]>
    {
        return this.http
        .post(this.backendUrl + `garments/listbyrfids`, rfidList)
        .map(this.extractData)
        .catch(this.handleError);
    }

    getGarmentListByProductidsList(productId: Array<number>): Observable<Garment[]>
    {
        return this.http
        .post(this.backendUrl + `/garments/listbyProductids`, productId)
        .map(this.extractData)
        .catch(this.handleError);
    }

    refreshGarmentList(customerId: string, ownerId: number): void
    {
        this.http
            .get(this.backendUrl + `garments/${ownerId}`)
            .map(this.extractData)
            .subscribe(
                res => this.garmentListSubject.next(res),
                err => console.error(err)
            );
    }

    getGarment(customerId: string, ownerId: number, garmentId: number): void
    {
        // const garment = this.garmentList.find(x => x.id === garmentId);
        // if (garment)
        // {
        //     this.garmentSubject.next(garment);
        // } 
        // else
        // {
        //     this.http
        //         // METHOD DOESN'T EXIST SERVER SIDE YET
        //         .get(this.backendUrl + `garments/${ ownerId }/${ garmentId }`)
        //         .map(this.extractData)
        //         .subscribe(
        //             res => this.garmentSubject.next(res),
        //             err => console.error(err)
        //         );
        // }        
    }

    getGarmentByID$(garmentId): Observable<Garment>
    {
        // let url = this.instanceService.isInstanceMaster() ? 'garments-master/id/' + garmentId : 'garments/id/' + garmentId;
        let url = 'garments/id/' + garmentId;

        return this.http.get(this.backendUrl + url)
            .map(this.extractData)
            .catch(this.handleError);

        // return this.http.get(this.backendUrl + `garments/id/${ garmentId }`)
        //     .map(this.extractData)
        //     .catch(this.handleError);
    }

    getGarmentByRFID(rfid)
    {
        //console.log('getGarmentByRFID() called');
        // let url = this.instanceService.isInstanceMaster() ? 'garments-master/rfid/' : 'garments/rfid/';
        let url = 'garments/rfid/';
        return this.getGarmentByRFIDByURL(rfid, url);
    }

    private getGarmentByRFIDByURL(rfid, url)
    {
        if (!this.isLastRecentTag(rfid)) // Needed to prevent erroneous multiple readings
        {
            //console.log('RFID or Barcode ' + rfid + ' not read at least since ' + this.lastGarmentReadDate.toString());

            this.lastGarmentReadDate = new Date();
            this.setSelectedTag(rfid);

            return this.http.get(this.backendUrl + url + rfid) //`garments/rfid/${ rfid }`
                .map(this.extractData)
                .catch(this.handleError);
        }
        else
        {
            //console.log('RFID or Barcode ' + rfid + ' read twice on ' + this.lastGarmentReadDate.toString());
            throw new Error("Same garment already read few seconds ago.");
        }
    }


    getGarmentPhase$(garmentId): Observable<Status>
    {
        return this.http.get(this.backendUrl + `garments/${garmentId}/phase`)
            .map(this.extractData)
            .catch(this.handleError);
    }

    setGarment(garment: Garment)
    {
        return this.http.post(this.backendUrl + 'garments', garment)
            .map(this.extractData)
            .catch(this.handleError);
    }

    setGarmentList(garments: Garment[])
    {
        return this.http.post(this.backendUrl + 'garmentslist', garments)
            .map(this.extractData)
            .catch(this.handleError);
    }

    updateGarment$(garment: Garment): Observable<Garment>
    {
        return this.http
            .post(this.backendUrl + 'garments', garment)
            .map(this.extractData)
            .catch(this.handleError)
    }

    moveGarmentsToWarehouse$(garmentList: Garment[]): Observable<boolean>
    {
        return this.http
            .post(this.backendUrl + '/garments/move/warehouse', garmentList)
            .map(this.extractData)
            .catch(this.handleError)
    }

    getGarmentsInProcessByEndUser$(endUserId: number): Observable<Garment[]>
    {
        return this.http.get(this.backendUrl + "garments/inprocess/end-user/" + endUserId)
            .map(this.extractData)
            .catch(this.handleError);
    }

    //Simo:
    getGarmentsLockedByEndUser$(endUserId: number): Observable<Garment[]>
    {
        return this.http.get(this.backendUrl + "garments/locked/end-user/" + endUserId)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getGarmentsInProcessFiltered$(startDate:Date, endDate:Date, structureId, areaId, endUserId): Observable<Garment[]>
    {
        return this.http.get(this.backendUrl + `garments/inprocess/${startDate}/${endDate}/${structureId}/${areaId}/${endUserId}`)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getGarmentsLockedFiltered$(year, month, structureId, areaId, endUserId): Observable<Garment[]>
    {
        return this.http.get(this.backendUrl + `garments/locked/${year}/${month}/${structureId}/${areaId}/${endUserId}`)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getGarmentsOnShelfByEndUser$(endUserId: number): Observable<Garment[]>
    {
        return this.http.get(this.backendUrl + "garments/onshelf/end-user/" + endUserId)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getLaundryMovementList$(year, month, structureId, areaId, endUserId): Observable<LaundryInputOutput[]>
    {
        return this.http.get(this.backendUrl + `laundry-movements/${year}/${month}/${structureId}/${areaId}/${endUserId}`)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getLaundryMovementListPeriod(startDate: Date, endDate: Date, structureId, areaId, endUserId): Observable<LaundryInputOutput[]>
    {
        return this.http.get(this.backendUrl + `laundry-movements-period/${startDate}/${endDate}/${structureId}/${areaId}/${endUserId}`)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getLaundryMovementListInputByGarmentCount$(garmentId: number): Observable<number>
    {
        return this.http.get(this.backendUrl + `laundry-movements/input/count/garment/${garmentId}`)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getLaundryMovementListOutputByGarmentCount$(garmentId: number): Observable<number>
    {
        return this.http.get(this.backendUrl + `laundry-movements/output/count/garment/${garmentId}`)
            .map(this.extractData)
            .catch(this.handleError);
    }


    // was LaundryInputOutput
    getGarmentMovements$(garmentId): Observable<LaundryEvent[]>
    {
        return this.http.get(this.backendUrl + `laundry-movements/garment/${garmentId}`)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getGarmentMovementsMaster$(garmentId, instanceId): Observable<LaundryEvent[]>
    {
        return this.http.get(this.backendUrl + `laundry-movements-master/garment/id/${garmentId}/instance/${instanceId}`)
            .map(this.extractData)
            .catch(this.handleError);
    }

    setLaundryInput(laundryInput: LaundryInputOutput): Observable<any>
    {
        // let url = this.instanceService.isInstanceMaster() ? 'laundry-input-master' : 'laundry-input';
        let url = 'laundry-input';

        return this.http.post(this.backendUrl + url, laundryInput)
            .map(this.extractData)
            .catch(this.handleError);
    }

    setLaundryInputMultiple(rfidList: string[], catering: string, structureId:number): Observable<string[]>
    {
        return this.http.post(this.backendUrl + `laundry-input-multiple/${catering}/${structureId}`, rfidList)
            .map(this.extractData)
            .catch(this.handleError);
    }

    setLaundryOutput(laundryOutput: LaundryInputOutput): Observable<any>
    {
        // let url = this.instanceService.isInstanceMaster() ? 'laundry-output-master' : 'laundry-output';
        let url = 'laundry-output';

        return this.http.post(this.backendUrl + url, laundryOutput)
            .map(this.extractData)
            .catch(this.handleError);
    }
    setLaundryOutputBulk(laundryOutput: LaundryInputOutput[]): Observable<any>
    {
        // let url = this.instanceService.isInstanceMaster() ? 'laundry-output-master' : 'laundry-output';
        let url = 'laundry-output-bulk';

        return this.http.post(this.backendUrl + url, laundryOutput)
            .map(this.extractData)
            .catch(this.handleError);
    }

    setLaundryDelivery(laundryDelivery: LaundryDelivery): Observable<any>
    {
        //let url = this.instanceService.isInstanceMaster() ? 'laundry-delivery-master' : 'laundry-delivery';
        let url = 'laundry-delivery';

        return this.http.post(this.backendUrl + url, laundryDelivery)
            .map(this.extractData)
            .catch(this.handleError);
    }

    setLaundryDeliverySingleGarment(laundryDelivery: LaundryDelivery): Observable<any>
    {
        // let url = this.instanceService.isInstanceMaster() ? 'laundry-delivery-master' : 'laundry-delivery';
        let url = 'laundry-delivery';

        return this.http.post(this.backendUrl + url + '/garment', laundryDelivery)
            .map(this.extractData)
            .catch(this.handleError);
    }

    deleteLastLaundryOutput(garmentId: number)
    {
        return this.http.delete(this.backendUrl + `laundry-output/garment/${garmentId}`)
            .map(this.extractData)
            .catch(this.handleError);
    }


    setLaundryDeliveryShelf(laundryDelivery: LaundryDelivery): Observable<any>
    {
        // let url = this.instanceService.isInstanceMaster() ? 'laundry-delivery-shelf-master' : 'laundry-delivery-shelf';
        let url = 'laundry-delivery-shelf';

        return this.http.post(this.backendUrl + url, laundryDelivery)
            .map(this.extractData)
            .catch(this.handleError);
    }

    setLaundryDeliveryStructure(laundryDelivery: LaundryDelivery, structureId: number): Observable<any>
    {
        // let url = this.instanceService.isInstanceMaster() ? 'laundry-delivery-structure-master' : 'laundry-delivery-structure';
        let url = 'laundry-delivery-structure';

        return this.http.post(this.backendUrl + `${url}/${structureId}`, laundryDelivery)
            .map(this.extractData)
            .catch(this.handleError);
    }
    setLaundryDeliveryArea(laundryDelivery: LaundryDelivery, areaId: number): Observable<any>
    {
        // let url = this.instanceService.isInstanceMaster() ? 'laundry-delivery-area-master' : 'laundry-delivery-area';
        let url = 'laundry-delivery-area';

        return this.http.post(this.backendUrl + `${url}/${areaId}`, laundryDelivery)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getWashingTypeList(): WashingType[]
    {
        if(!this.washingTypeList)
            this.preloadLookups();
        return this.washingTypeList;
    }
    getWashingType(washingTypeId: number): WashingType
    {
        return this.getWashingTypeList().find(x => x.id == washingTypeId);
    }
    getWearLevelList(): WearLevel[]
    {
        return this.wearLevelList;
    }
    getLockReasonList(laundryMode: string): LockReason[]
    {
        if (laundryMode === 'in')
            return this.lockReasonInList;
        else
            return this.lockReasonOutList;
    }

    getWearLevel(wearLevelId: number): WearLevel
    {
        throw new Error('Method not implemented.');
    }

    getSelectedTag(): string
    {
        return this.selectedTag;
    }
    setSelectedTag(tag: string)
    {
        this.selectedTag = tag;
    }

    getSelectedProduct(): Product
    {
        return this.selectedProduct;
    }
    setSelectedProduct(product: Product)
    {
        this.selectedProduct = product;
        this.selectedProduct.garments = []
        this.getGarmentListByProductidsList([product.id]).subscribe(gs => this.selectedProduct.garments = gs)
    }

    getSelectedEndUser(): IPerson
    {
        return this.selectedEndUser;
    }
    setSelectedEndUser(endUser: IPerson)
    {
        this.selectedEndUser = endUser;
    }

    getSelectedGarment(): Garment
    {
        return this.selectedGarment;
    }
    setSelectedGarment(garment: Garment)
    {
        this.selectedGarment = garment;
    }


    getFilledShelfList$(shelfNumber: number): Observable<ShelfBoxMicro[]>
    {
        // let url = this.instanceService.isInstanceMaster() ? 'shelf-boxes-micro-master/' : 'shelf-boxes-micro/';
        let url = 'shelf-boxes-micro/';

        return this.http.get(this.backendUrl + url + shelfNumber)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getFilledShelfListOld$(shelfNumber: number): Observable<ShelfBox[]>
    {
        return this.http.get(this.backendUrl + 'shelf-boxes/' + shelfNumber)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getFilledVoidedBox(): Observable<ShelfBox>
    {
        return this.http.get(this.backendUrl + 'shelf-box-voided')
            .map(this.extractData)
            .catch(this.handleError);
    }

    // TODO: remove it when possible, the total boxes size is already calculated by the Shelf Component!
    // getShelfCapacity(): number
    // {
    //     return 30;
    // }

    getSelectedShelfBox(): ShelfBox
    {
        return this.selectedShelfBox;
    }
    setSelectedShelfBox(box: ShelfBox)
    {
        this.selectedShelfBox = box;
    }

    getSelectedShelfNumber(): number
    {
        return this.selectedShelfNumber;
    }
    setSelectedShelfNumber(shelfNumber: number)
    {
        this.selectedShelfNumber = shelfNumber;
    }

    getSelectedDeliveryMode(): string
    {
        return this.selectedDeliveryMode;
    }
    setSelectedDeliveryMode(mode: string)
    {
        this.selectedDeliveryMode = mode;
    }

    removeGarmentsFromShelfBox(shelfBox: number)
    {
        return this.http.delete(this.backendUrl + 'shelf-boxes/' + shelfBox)
            .map(this.extractData)
            .catch(this.handleError).subscribe();
    }

    removeGarmentsFromShelf(shelf: number)
    {
        return this.http.delete(this.backendUrl + 'shelfs/' + shelf)
            .map(this.extractData)
            .catch(this.handleError);
    }

    isLastRecentTag(tag: string): boolean
    {
        // console.log('++++ tag: ' + tag + ' - selectedTag:' + this.selectedTag);

        if (tag === this.selectedTag)
        {

            // console.log('Now: ' + new Date().getTime().toString() + ' - Last Garment Read: ' + this.lastGarmentReadDate.getTime().toString());
            if (new Date().getTime() - this.lastGarmentReadDate.getTime() < this.MIN_INTERVAL_BETWEEN_TAG_SCAN)
            {
                return true;
            }
        }

        return false;
    }

    getAvailableShelfboxIds$(areaId: number): Observable<number[]>
    {
        return this.http.get(this.backendUrl + 'shelf-box-ids/area/' + areaId)
            .map(this.extractData)
            .catch(this.handleError);
    }


    getGarmentsReport(year, month, structureId, areaId, endUserId): Observable<any>
    {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http.get(this.backendUrl + `reports/garments/${year}/${month}/${structureId}/${areaId}/${endUserId}`,
            { headers: headers, responseType: 'blob' as 'json' });
    }

    getGarmentsXLSReport(startDate:Date, endDate:Date, structureId, areaId, endUserId): Observable<any>
    {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        return this.http.get(this.backendUrl + `reports/xls/garments/${startDate}/${endDate}/${structureId}/${areaId}/${endUserId}`,
            { headers: headers, responseType: 'blob' as 'json' });
    }

    // getGarmentsReportSimplified(year, month, structureId, areaId, endUserId): Observable<any>
    // {
    //     let headers = new HttpHeaders();
    //     headers = headers.set('Accept', 'application/pdf');
    //     return this.http.get(this.backendUrl + `reports/garments/simplified/${year}/${month}/${structureId}/${areaId}/${endUserId}`,
    //         { headers: headers, responseType: 'blob' as 'json' });
    // }

    // getGarmentsXLSReportSimplified(year, month, structureId, areaId, endUserId): Observable<any>
    // {
    //     let headers = new HttpHeaders();
    //     headers = headers.set('Accept', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    //     return this.http.get(this.backendUrl + `reports/xls/garments/simplified/${year}/${month}/${structureId}/${areaId}/${endUserId}`,
    //         { headers: headers, responseType: 'blob' as 'json' });
    // }


    getUsersOutputReport(year: any, month: any, structureId: any): Observable<any>
    {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http.get(this.backendUrl + `reports/end-users/${year}/${month}/${structureId}`,
            { headers: headers, responseType: 'blob' as 'json' });
    }

    getUsersOutputXLSReport(year: any, month: any, structureId: any): Observable<any>
    {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        return this.http.get(this.backendUrl + `reports/xls/end-users/${year}/${month}/${structureId}`,
            { headers: headers, responseType: 'blob' as 'json' });
    }

    getUsersWardrobeOutputReport(endUserId: any): Observable<any>
    {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http.get(this.backendUrl + `reports/end-user-wardrobe/${endUserId}`,
            { headers: headers, responseType: 'blob' as 'json' });
    }
    
    getUsersWardrobeOutputReportXLS(endUserId: any): Observable<any>
    {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        return this.http.get(this.backendUrl + `reports/xls/end-user-wardrobe/${endUserId}`,
            { headers: headers, responseType: 'blob' as 'json' });
    }

    getGarmentMovementsReport(garmentId: any): Observable<any>
    {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http.get(this.backendUrl + `reports/garment-movements/${garmentId}`,
            { headers: headers, responseType: 'blob' as 'json' });
    }

    getGarmentMovementsXLSReport(garmentId: any): Observable<any>
    {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        return this.http.get(this.backendUrl + `reports/xls/garment-movements/${garmentId}`,
            { headers: headers, responseType: 'blob' as 'json' });
    }

    printGenerateBarcode(endUserId: number, barcode: string, labelType: number): Observable<any>
    {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http.get(this.backendUrl + `garments/generate-barcode/${endUserId}/${barcode}/${labelType}`,
            { headers: headers, responseType: 'blob' as 'json' });
    }

    getBarcodeImage(endUserId: number, barcode: string, labelType: number): Observable<any>
    {
        return this.http.get(this.backendUrl + `garments/generate-barcode-image/${endUserId}/${barcode}/${labelType}`)
        .map(this.extractData)
        .catch(this.handleError);
    }

    getDeliveryLabel(laundryDelivery: LaundryDelivery): Observable<any>
    {
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http.post(this.backendUrl + `labels/delivery`, laundryDelivery,
            { headers: headers, responseType: 'blob' as 'json' });
    }


    // uploadImage(base64Image: string): Observable<any>
    // {
    //     return this.http.post(this.backendUrl + 'upload-image', base64Image)
    //         .map(this.extractData)
    //         .catch(this.handleError);
    // }

    lockGarment(laundryEvent: LaundryEvent): Observable<any>
    {
        return this.http.post(this.backendUrl + 'garments/lock', laundryEvent)
            .map(this.extractData)
            .catch(this.handleError);
    }

    unlockGarment(laundryEvent: LaundryEvent): Observable<any>
    {
        return this.http.post(this.backendUrl + 'garments/unlock', laundryEvent)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getLaundryEvent(eventId: number): Observable<LaundryEvent>
    {
        return this.http.get(this.backendUrl + `laundry-events/${eventId}`)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getLaundryEventMaster(eventId: number, instanceId: number): Observable<LaundryEvent>
    {
        return this.http.get(this.backendUrl + `laundry-events-master/${eventId}/instance/${instanceId}`)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getLastLaundryEvent(garmentId: number): Observable<LaundryEvent>
    {
        return this.http.get(this.backendUrl + `laundry-events/${garmentId}/last`)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getTagHistory(rfid: string): Observable<Garment[]>
    {
        return this.http.get(this.backendUrl + `garments/history/tag/${rfid}`)
            .map(this.extractData)
            .catch(this.handleError);
    }

    
}






// WEBPACK FOOTER //
// ./src/app/+core/common/services/core.service.ts